import fetch from './fetch'

class ReconciliationApi {
	public getList(form: any) {
		return fetch({
			url: 'injury/statement/list',
			method: 'post',
			data: form,
		})
	}

	public synch(form: any) {
		return fetch({
			url: 'injury/statement/synch',
			method: 'post',
			params: form,
		})
	}

	public resynch(form: any) {
		return fetch({
			url: 'injury/statement/resynch',
			method: 'post',
			params: form,
		})
	}

	public resynchByOrder(orderNo: string) {
		return fetch({
			url: 'injury/statement/resynchByOrder',
			method: 'post',
			params: { orderNo },
		})
	}
}

export default new ReconciliationApi()
